import React, { useEffect, useState } from 'react';
import './App.css';
import MainLayout from './components/common/layouts/main-layout.tsx';
import AppRouter from './components/router';
import useAuthorization from './core/services/hooks/useAuthorization.ts'
import AdminService from './core/services/AdminService.ts';
import useFetch from './core/hooks/useFetch.ts';
import "./utils/pdf.ts";
import useAutoLogout from './core/services/hooks/useAutoLogout.ts'
import { useAppDispatch, useAppSelector } from './core/store/index.ts';
import { setSettings } from './core/store/reducers/settings-site.ts';
import { useNavigate } from 'react-router';
import WebsocketService from './core/services/WebsocketService.ts';
import {WebsocketContext} from './core/context/WebsocketContext.ts'
function App() {
  const [ws] = useState(() => new WebsocketService("wss://fin-rassvet.su/ws/"))
  const dispatch = useAppDispatch()
  const settings = useAppSelector(state => state.settings.settings)
  const {authorization, isLoading, error, errors} = useAuthorization()
  const navigate = useNavigate()
  const [fetchSettingsSite, isLoadingSettingsSite, errorSettingsSite, errorsSettingsSite] = useFetch(async () => {
        const data = await AdminService.GetSettingsSite()
        dispatch(setSettings(data))
        document.title = data.name_site
  })
  const bootstrap = async () => {
    await authorization()
    await fetchSettingsSite()
  }
  useEffect(() => {
     bootstrap()
  }, [])
  useEffect(() => {
        navigate(JSON.parse(window.sessionStorage.getItem('lastRoute') || '{}'))
        window.onbeforeunload = () => {
            window.sessionStorage.setItem('lastRoute', JSON.stringify(window.location.pathname))
        }
    }, [])
    useEffect(() => {
      ws.connect()

      return () => {
        ws.disconnect()
      }
    }, [ws])
    useAutoLogout({timeout: 15 * 60 * 1000})
   
  return (
    <WebsocketContext.Provider value={ws}>
    <MainLayout>
       <head>
        <link rel="shortcut icon" href={settings?.favicon_ico_url || ''} type="image/x-icon" />
      </head>
      <AppRouter 
       
      />
    </MainLayout>
    </WebsocketContext.Provider>
  );

}

export default App;
